<template>
  <div
    v-click-outside="handleClickOutside"
    class="relative w-full flex justify-end"
    @click="open = !open"
  >
    <button class="flex items-center gap-2 hover:bg-secondary-light/20 rounded hover:border-primary px-2.5 py-2 duration-200 hover:text-white group">
      <span class="bg-secondary text-white font-semibold rounded-full w-8 h-8 flex items-center justify-center text-xs">
        {{ store.user.firstName[0].toUpperCase() }}{{ store.user.lastName[0].toUpperCase() }}
      </span>

      <span class="font-semibold text-gray-800 text-sm hidden lg:flex">
        {{ store.user.firstName }} {{ store.user.lastName }}
      </span>
    </button>

    <div
      v-if="open"
      class="absolute min-w-36 bg-white shadow top-14 right-0 rounded border z-[60]"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useAuthStore } from '@/store';

const store = useAuthStore();

const open = ref(false);

const handleClickOutside = () => {
  open.value = false;
};
</script>
